<template>
  <div class="c-app dashboard" >
      <div class="c-body " >
        <Header v-if="show_header()"/>

        <main class="c-main" >
          <div class="header-padding" v-if="show_header()"></div>
          <v-container class="container--fluid" style="height: 100%;padding: 0px">
            <Loading />
            <transition name="fade" mode="out-in">
              <router-view :key="$route.path">

              </router-view>
            </transition>
          </v-container>





        <Dialog/>
        </main>

      </div>
  </div>
</template>

<script>

import Loading from './Loading.vue'
import Header from './Header.vue'
import Dialog from './Dialog.vue'
import {bus} from '../main.js'
import {wb} from '../main.js'
import Vue from "vue";
export default {
  name: 'TheContainer',
  components: {
    Loading,
    Header,
    Dialog,
  }
  ,data () {
    return {
      dialog_show : false,
      dialog_title: '',
      dialog_summary : '',
      contosoChatHubProxy:null,
      broadcast:null,
      messageChannel:null,
    }
  },
  mounted() {

    bus.$on('show_dialog', (name) => {
      console.log('bus', name)
        this.dialog_show = true;
        this.dialog_title = name[0];
        this.dialog_summary = name[1];

      // setTimeout(this.load = name , 1000)
    })


    // this.config_signalr();
    //******************************************
//******************************************
    if(1==0){//disable broadcast channel
      try {
        this.broadcast = new BroadcastChannel('count-channel');
        this.broadcast.onmessage = (event) => {
          console.log(event.data.payload);
        };

        this.broadcast.onmessage = (event) => {
          if (event.data && event.data.type === 'BroadcastToBus') {
            bus.$emit(event.data.event, event.data.args)
          }
        };
      } catch {
        console.log("broadcast not support")
      }
    }


    try {
      this.messageChannel = new MessageChannel();

      addEventListener('message', (event) => {
        // console.log("message channel received in container",event)

        // if (event.data && event.data.type === 'SignalInvoke') {
        if (event.data && event.data.type === 'BroadcastToBus') {
          bus.$emit(event.data.event, event.data.args)
        }
      });

    } catch(e) {
      console.log("message channel not support",e)
    }

//********************************************

    bus.$on('signalr_invokes', (json_data) => {
      this.postMsgChannel({
        type: 'SignalInvoke',
        data: json_data
      });
    })

// Listen to the response


// Send first request

  },
  methods:{
    postMsgChannel(message) {
      // try{
      //   this.broadcast.postMessage(message);
      // }catch (e) {
      //   console.log("broadcast channel message error send")
      //
      // }
      try{
        // this.messageChannel.postMessage(message);
        postMessage(message, [this.messageChannel.port1]);

      }catch (e) {
        console.log("message channel message error send",e)

      }
    },
    show_header(){
      if(this.$router.currentRoute.fullPath == "/home-tab"){
        return false;
      }
      if(this.$router.currentRoute.fullPath == "/message-tab"){
        return false;
      }
      if(this.$router.currentRoute.fullPath == "/profile-tab"){
        return false;
      }
      if(this.$router.currentRoute.fullPath == "/login"){
        return false;
      }if(this.$router.currentRoute.fullPath == "/post-login"){
        return false;
      }if(this.$router.currentRoute.fullPath == "/chat-detail"){
        return false;
      }if(this.$router.currentRoute.fullPath == "/contacts"){
        return false;
      }
      return  true;
    },
    config_signalr(){
     var self = this;
      $.connection.hub.url = 'https://panel.zoodkomak.com/signalr';

      this.contosoChatHubProxy = $.connection.zoodKomakHub;
      console.log(this.contosoChatHubProxy)

      this.contosoChatHubProxy.client.getMessages = function (message) {
        console.log("get message", message);
        bus.$emit('signalr_methods', ['get_message',message])

      };
      this.contosoChatHubProxy.client.GetNotifFromNewZk = function (message) {
        console.log("new notif zoodkomak",message)
        var json_mesage = JSON.parse(message)
        if(json_mesage.func == 'online_request_confirmed'){
          var message = "درخواست " + json_mesage.data.request.type_name + " " + json_mesage.data.request.group_name + " " + json_mesage.data.request.subgroup_name + " " +
            " توسط " + json_mesage.data.user.name+" تایید شد."
          bus.$emit('show_dialog', ["درخواست شما تایید گردید", message ])
          bus.$emit('online_request_updated',true)

        }
        if(json_mesage.func == 'online_request_canceled'){
          var message = "متاسفانه برای درخواست " + json_mesage.data.request.type_name + " " + json_mesage.data.request.group_name + " " + json_mesage.data.request.subgroup_name + " " +
            " کارشناسی یافت نشد "
          bus.$emit('show_dialog', ["درخواست لغو گردید", message ])
          bus.$emit('online_request_updated',true)

          }

          // bus.$emit('signalr_methods', ['get_message', message])
      }
      this.contosoChatHubProxy.client.MessagesNotRead = function (message) {
        // console.log("MessagesNotRead", message);
      };
      this.contosoChatHubProxy.client.GetInboxRead = function (message) {
        console.log('GetInboxRead', message);
        bus.$emit('signalr_methods', ['read_message',message])

      };
      this.contosoChatHubProxy.client.UserFired = function (message) {
        // console.log("UserFired", message);
      };
      this.contosoChatHubProxy.client.GetIsTyping = function (message) {
        // console.log( message);
        bus.$emit('signalr_methods', ['is_typing',message])
      };
      this.contosoChatHubProxy.client.GetUserOnlineStatus = function (message) {
        // console.log("GetUserOnlineStatus", message);
      };
      this.contosoChatHubProxy.client.getTechTrackInfo = function (message) {
        // console.log( message);
      };

      this.start_hub_connection();
    },
    start_hub_connection(){
      var self = this;
      $.connection.hub.start()
        .done(function(){

          console.log('Now connected, connection ID=' + $.connection.hub.id);
          var user_data = JSON.parse(localStorage.getItem("profile"))
          var userId = user_data.UserId;
          self.signalr_invokes('connect',"{\"userId\":\""+userId+"\"}")


        })
        .fail(function(){ console.log('Could not Connect!'); });


      $.connection.hub.disconnected(function () {
        // console.log('Server has disconnected1');
        // self.start_hub_connection()
        // $.connection.hub.start();

      });
      $.connection.hub.stateChanged(function (change) {
        if (change.newState === $.signalR.connectionState.reconnecting) {
          // console.log('Server has reconecting');
        }
        else if (change.newState === $.signalR.connectionState.connected) {
          // console.log('Server has connected');
        }
        else if (change.newState === $.signalR.connectionState.disconnected) {
          // console.log('Server has dis111connected');
          setTimeout(function() {
            $.connection.hub.start();
          }, 1000);

        }
      });
    },
    signalr_invokes(method,args){
      if(method=='connect'){
        this.contosoChatHubProxy.server.connect(args).done(function () {
          console.log ('Invocation of connect succeeded');
        }).fail(function (error) {
          console.log('Invocation of connect failed. Error: ' + error);
        });
      }
//************************************************
      if(method=='send_message'){
        this.contosoChatHubProxy.server.sendMessageToGroup(args).done(function () {
          console.log ('Invocation of send_message succeeded ');
        }).fail(function (error) {
          console.log('Invocation of send_message failed. Error: ' + error);
        });
      }
//************************************************
      if(method=='is_typing'){

        this.contosoChatHubProxy.server.sendIsTyping(args).done(function () {
          console.log ('Invocation of is_typing succeeded',args);
        }).fail(function (error) {
          console.log('Invocation of is_typing failed. Error: ' + error);
        });
      }
      //************************************************
      if(method=='delete_connection'){
        this.contosoChatHubProxy.server.deleteConnection(args).done(function () {
          console.log ('Invocation of delete_connection succeeded');
        }).fail(function (error) {
          console.log('Invocation of delete_connection failed. Error: ' + error);
        });
      }
//************************************************
if(method=='delete_connection'){
        this.contosoChatHubProxy.server.deleteConnection(args).done(function () {
          console.log ('Invocation of delete_connection succeeded');
        }).fail(function (error) {
          console.log('Invocation of delete_connection failed. Error: ' + error);
        });
      }
//************************************************
if(method=='add_online'){
        this.contosoChatHubProxy.server.addUserOnline(args).done(function () {
          console.log ('Invocation of add_online succeeded');
        }).fail(function (error) {
          console.log('Invocation of add_online failed. Error: ' + error);
        });
      }
//************************************************
if(method=='send_read'){
        this.contosoChatHubProxy.server.addToInboxRead(args).done(function () {
          console.log ('Invocation of add_online succeeded');
        }).fail(function (error) {
          console.log('Invocation of add_online failed. Error: ' + error);
        });
      }
//************************************************
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
